export default __webpack_public_path__ + "static/media/kirby.fdb289f8.svg";